
import {lazy,useEffect,useState, useMemo} from "react";
import routesRecargaCupoWithPasarela from "../apps/RecargaCupo/Pasarelas/routes";
import { useFetch } from "./useFetch";
import { fetchCustom } from "../apps/BloqueosCierreFinanciero/utils/fetchComerciosCierreFinanciero";
import { useAuth } from "./AuthHooks";

const AppIcons = lazy(() => import("../components/Base/AppIcons"));

const CorresponsaliaDavivienda = lazy(() => import("../apps/Corresponsalia/CorresponsaliaDavivienda/CorresponsaliaDavivienda"));
const Corresponsalia = lazy(() => import("../apps/Corresponsalia/Corresponsalia"));
const DaviplataCB = lazy(() => import("../apps/Corresponsalia/CorresponsaliaDavivienda/Views/Daviplata"));
const CashOut = lazy(() => import("../apps/Corresponsalia/CorresponsaliaDavivienda/Views/Daviplata/Retiro"));

const RecaudoEntryPoint = lazy(() => import("../apps/RecaudoDirecto/RecaudoEntryPoint"));
const RetiroDirecto = lazy(() => import("../apps/RecaudoDirecto/Views/Retiro/RetiroDirecto"));
const FormularioRetiro = lazy(() => import("../apps/RecaudoDirecto/Views/Retiro/FormularioRetiro"));

const CorresponsaliaGrupoAval = lazy(() => import("../apps/Corresponsalia/CorresponsaliaGrupoAval/CorresponsaliaGrupoAval"));
const AhorrosCorriente = lazy(() => import("../apps/Corresponsalia/CorresponsaliaGrupoAval/Views/AhorrosCorriente"));
const RetiroGrupoAval = lazy(() => import("../apps/Corresponsalia/CorresponsaliaGrupoAval/Views/AhorrosCorriente/Retiro"));

const CorresponsaliaItau = lazy(() => import("../apps/Corresponsalia/CorresponsaliaItau/CorresponsaliaItau"));
const RetiroItau = lazy(() => import("../apps/Corresponsalia/CorresponsaliaItau/Views/TrxCuentas/Retiro"));

const CorresponsaliaBancoAgrario = lazy(() => import("../apps/Corresponsalia/CorresponsaliaBancoAgrario/CorresponsaliaBancoAgrario"));
const TrxCuentasBancoAgrario = lazy(() =>import("../apps/Corresponsalia/CorresponsaliaBancoAgrario/CorresponsaliaBancoAgrario"));
const RetiroEfectivoBancoAgrario = lazy(() =>import("../apps/Corresponsalia/CorresponsaliaBancoAgrario/Views/TrxCuentas/RetiroEfectivo"));

const PagoGiro = lazy(() => import("../apps/Corresponsalia/CorresponsaliaDavivienda/Views/Daviplata/PagoGiro"));

const AhorrosCorrienteCB = lazy(() => import("../apps/Corresponsalia/CorresponsaliaDavivienda/Views/AhorrosCorriente"));
const RetiroCB = lazy(() => import("../apps/Corresponsalia/CorresponsaliaDavivienda/Views/AhorrosCorriente/Retiro"));

const PagoTerceros = lazy(() => import("../apps/Corresponsalia/CorresponsaliaGrupoAval/Views/PagoTerceros/PagoTerceros"));
const PagoSubsidios = lazy(() => import("../apps/Corresponsalia/CorresponsaliaGrupoAval/Views/PagoSubsidios/PagoSubsidios"));

const ColpatriaTrx = lazy(() => import("../apps/Colpatria/ColpatriaTrx"));
const ColpatriaPagoGiro = lazy(() => import("../apps/Colpatria/Views/PagoGiro"));
const PinDePago = lazy(() => import("../apps/Colpatria/Views/PinDePago"));

const MoviiPDP = lazy(() => import("../apps/Corresponsalia-Movii/CorresponsalMovii"));
const MoviiPDPCashOut = lazy(() => import("../apps/Corresponsalia-Movii/Views/Movii/RetiroMovii"));

const CorresponsaliaPowwi = lazy(() => import("../apps/Powwi/CorresponsaliaPowwi"));
const RetiroPowwi = lazy(() => import("../apps/Powwi/Views/Operaciones/Retiro"));

const RecargaCupoMenu = lazy(() => import("../apps/RecargaCupo/RecargaCupoMenu"));

const URL_COMERCIOS = `${process.env.REACT_APP_URL_SERVICE_COMMERCE}/bloqueo_cierre_financiero/consulta_bloqueos`;

export const createSubRoute = (link, labellogo, label, component, permission, subRoutes = []) => ({
  link,
  label: <AppIcons Logo={labellogo} name={label} />,
  component,
  permission,
  subRoutes,
});

export const createRoutes = (baseLink, baseLabellogo, baseLabel, baseComponent, basePermission, subRoutesConfig = []) => ({
  link: baseLink,
  label: <AppIcons Logo={baseLabellogo} name={baseLabel} />,
  component: baseComponent,
  permission: basePermission,
  subRoutes: subRoutesConfig
});

export const Routes = [
    createRoutes("/corresponsalia", "CORRESPONSALIA", "Corresponsalía", Corresponsalia, [5002,5003,5005,15001,15002,15003,40001,16001,6005,6006], [
        createRoutes("/corresponsalia/corresponsaliaDavivienda", "DAVIVIENDA", "Corresponsalía Davivienda", CorresponsaliaDavivienda, [5002,5003,5005], [
            // Retiro Daviplata
            createRoutes("/corresponsalia/corresponsaliaDavivienda/Daviplata", "DAVIPLATA", "DaviPlata", DaviplataCB, [5002], [
                createSubRoute("/corresponsalia/corresponsaliaDavivienda/DaviplatacashOut", "DAVIPLATA_RETIRO", "Retiro DaviPlata", CashOut, [5002])
            ]),
            //Pago Por Giro Davivienda
            createSubRoute("/corresponsalia/corresponsaliaDavivienda/Daviplatapagos_giros", "DAVIVIENDA_PAGO_POR_GIRO", "Pago por giro", PagoGiro, [5003]),
            //Retiro Davivienda
            createRoutes("/corresponsalia/corresponsaliaDavivienda/ahorrosCorriente", "DAVIVIENDA_RETIROS_Y_DEPOSITOS", "Retiros y Depósitos Davivienda", AhorrosCorrienteCB, [5005], [
                createSubRoute("/corresponsalia/corresponsaliaDavivienda/ahorrosCorriente/retiro", "DAVIVIENDA_RETIROS", "Retiros", RetiroCB, [5005])
            ]),
        ]),
        createRoutes("/corresponsalia/CorresponsaliaGrupoAval", "AVAL", "Corresponsalía Grupo Aval", CorresponsaliaGrupoAval, [15001,15002,15003], [
            //Retiro Grupo Aval
            createRoutes("/corresponsalia/CorresponsaliaGrupoAval/ahorrosCorriente", "AVAL_TRANSACCIONES_CUENTAS", "Transacciones cuentas Grupo Aval", AhorrosCorriente, [15001], [
                createSubRoute("/corresponsalia/CorresponsaliaGrupoAval/ahorrosCorriente/retiro", "AVAL_RETIROS", "Retiros", RetiroGrupoAval, [15001])
            ]),
            //Pago a Terceros Grupo Aval
            createSubRoute("/corresponsalia/CorresponsaliaGrupoAval/pagoterceros", "AVAL_PAGO_DE_TERCEROS", "Pago de terceros", PagoTerceros, [15002]),
            //Pago de Subsidios Grupo Aval
            createSubRoute("/corresponsalia/CorresponsaliaGrupoAval/pagosubsidios", "AVAL_PAGO_DE_SUBSIDIOS", "Pago de subsidios", PagoSubsidios, [15003])
        ]),
        //Retiro Itaú
        createRoutes("/corresponsalia/corresponsalia-itau", "ITAU", "Corresponsalía Itaú", CorresponsaliaItau, [40001], [
            createSubRoute("/corresponsalia/corresponsalia-itau/retiro", "MARKETPLACE", "Retiro", RetiroItau, [40001])
        ]),
        //Retiro BAC
        createRoutes("/corresponsalia/corresponsalia-banco-agrario", "AGRARIO", "Corresponsalía Banco Agrario", CorresponsaliaBancoAgrario, [16001], [
            createRoutes("/corresponsalia/corresponsalia-banco-agrario/transacciones-cuentas", "MARKETPLACE", "Transacciones cuentas Banco Agrario", TrxCuentasBancoAgrario, [16001], [
                createSubRoute("/corresponsalia/corresponsalia-banco-agrario/transacciones-cuentas/retiro", "MARKETPLACE", "Retiro", RetiroEfectivoBancoAgrario, [16001])
            ])
        ]),
        createRoutes("/corresponsalia", "COLPATRIA", "Corresponsalía Colpatria", ColpatriaTrx, [6005,6006], [
            //Retiro Con Pin Colpatria
            createSubRoute("/corresponsalia/pago-de-giro", "COLPATRIA_RETIRO_CON_PIN", "Retiro con Pin", ColpatriaPagoGiro, [6005]),
            //Pin de Pago Colpatria
            createSubRoute("/corresponsalia/pin-de-pago", "COLPATRIA_PIN_DE_PAGO", "Pin de Pago", PinDePago, [6006])
        ]),
        //Retiro BCS  
    ]),
    // Retiro Directo
    createRoutes("/recaudo-directo", "DAVIVIENDA_RETIROS_Y_DEPOSITOS", "Recaudo/Retiro Directos", RecaudoEntryPoint, [8002], [
        createRoutes("/recaudo-directo/consultar-retiro", "RETIRO", "Retiro Directo", RetiroDirecto, [8002], [
            createSubRoute("/recaudo-directo/consultar-retiro/:pk_id_convenio", "RETIRO", "Realizar retiro", FormularioRetiro, [8002])
        ])
    ]),
    //Retiro Movii
    createRoutes("/movii-pdp", "MOVII", "Movii", MoviiPDP, [49], [
        createSubRoute("/movii-pdp/retiro", "MOVII_RETIRO", "Retiro", MoviiPDPCashOut, [49])
    ]),
    //Retiro Powii
    createRoutes("/corresponsaliaPowwi", "POWWI", "Powwi", CorresponsaliaPowwi, [31002], [
        createSubRoute("/corresponsaliaPowwi/Retiro", "POWWI_RETIRO", "Retiro", RetiroPowwi, [31002])
    ]),
    //Recarga Cupo PSE y Recarga Cupo GOU
    createRoutes("/recarga-cupo", "RECARGA_CELULAR", "Recargar Cupo", RecargaCupoMenu, [700,800], [
        ...routesRecargaCupoWithPasarela
    ]),
];

// const useFetchComercios = () => {
//     const [comercios, setComercios] = useState([]);
//     const { commerceInfo } = useAuth();

//     const [loadingPeticionConsultaComercios,peticionConsultaComercios] = useFetch(
//         useMemo(() =>fetchCustom(URL_COMERCIOS, "POST", "Consultar Comercio bloqueados"),[])
//     );
  
//     useEffect(() => {
//         if (commerceInfo?.pk_comercio !== undefined) {
//             const fetchComercios = async () => {
//                 let obj = { id_comercio: commerceInfo?.pk_comercio };
//                 try {
//                     const autoArr = await peticionConsultaComercios({}, {
//                         ...obj,
//                         sortBy: "id_comercio",
//                         sortDir: "DESC",
//                     });
//                     setComercios(autoArr?.obj);
//                 } catch (err) {
//                 console.log(err)
//                 }
//             };  
//             fetchComercios();
//         }
//     }, [peticionConsultaComercios,commerceInfo?.pk_comercio]);
    
//     return { comercios };
// };

export const useDynamicRoutes  = () => {
    // const { comercios } = useFetchComercios();
    const [dynamicRoutes, setDynamicRoutes] = useState([]);

    // useEffect(() => {
    //     setDynamicRoutes(comercios.length === 0?[]:Routes)
    // }, [comercios]);

    return { dynamicRoutes };
};


